export const normalizeUserId = (userId) => String(userId ?? "");

export const getUnreadCountForUser = (unreadCountMap, userId) =>
  unreadCountMap?.[normalizeUserId(userId)] || 0;

export const isConversationUnreadForUser = (unreadCountMap, userId) =>
  getUnreadCountForUser(unreadCountMap, userId) > 0;

export const isLastMessageFromUser = (lastMessageSenderId, userId) =>
  normalizeUserId(lastMessageSenderId) === normalizeUserId(userId);

export const buildUnreadUserIds = (updatedUnread) =>
  Object.keys(updatedUnread).filter((uid) => (updatedUnread[uid] || 0) > 0);

export const clearSenderUnread = (updatedUnread, senderId) => {
  updatedUnread[normalizeUserId(senderId)] = 0;
  return updatedUnread;
};

export const shouldShowUnreadIndicatorForItem = (item, activeConversation) => {
  if (item.conversationId === activeConversation) {
    return false;
  }

  const unreadCount = item.unreadCount || 0;
  return unreadCount > 0 && !!item.isUnread;
};
